// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fav-popup {
  display: flex;
  flex-direction: column;
  padding: 5px 25px 25px 25px;
}
.fav-popup .close-button {
  background-color: white;
  align-self: flex-end;
}
.fav-popup .title {
  display: flex;
  align-self: center;
  font-size: x-large;
  font-weight: bold;
  transform: translateY(-33px);
}
.fav-popup .content {
  margin-top: 10px;
  align-self: center;
}`, "",{"version":3,"sources":["webpack://./src/app/popovers/popover-favourites/popover-favourites.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,2BAAA;AACJ;AACI;EACI,uBAAA;EACA,oBAAA;AACR;AACI;EACI,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,4BAAA;AACR;AACI;EACI,gBAAA;EACD,kBAAA;AACP","sourcesContent":[".fav-popup{\n    display: flex;\n    flex-direction: column;\n    padding: 5px 25px 25px 25px;\n\n    .close-button{\n        background-color: white;\n        align-self: flex-end;\n    }\n    .title{\n        display: flex;\n        align-self: center;\n        font-size: x-large;\n        font-weight: bold;\n        transform: translateY(-33px);\n    }\n    .content{\n        margin-top: 10px;\n       align-self: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
